import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Frame } from '../../components/shell/AppShell';
import PageHeader from '../../components/shell/PageHeader';
import InviteManagement from '../../components/admin/InviteManagement';
import adminArt from '../../assets/bg/founder-admin.webp';

/**
 * Invites: single-use onboarding links, valid 48 hours. Both staff roles may
 * create, list and revoke them -- the server allows exactly that -- so this
 * is the same page for both, with the server scoping what each sees.
 */
const Invites = () => {
  const { user } = useAuth();
  return (
    <Frame user={user} background={adminArt} scrim={0.55} activeKey="invites">
      <div data-testid="invites-page">
        <PageHeader title="Invites" subtitle="Single-use · valid 48 hours" />
        <div className="mx-auto max-w-5xl px-4 pb-6 pt-3">
          <div className="rounded-xl border border-border bg-card/90 p-3 md:p-5 backdrop-blur-sm">
            <InviteManagement />
          </div>
        </div>
      </div>
    </Frame>
  );
};

export default Invites;
